export const bottomFamilyTrackingFeatures = [
    {
        id: '1',
        title: 'Everyone Stays in the Loop',
        content: 'Forget “Where are you?” messages - Device Tracker Plus is designed for real families and keeps everyone up to date without constant texting or phone calls.',
        imgName: 'earth'
    },
    {
        id: '2',
        title: 'Helps Parents Plan Ahead',
        content: "Know if someone is running late before dinner is on the table or before heading out to pick them up. The app helps you manage your family's schedule with less stress and fewer surprises.",
        imgName: 'checkCircleIcon'
    },
    {
        id: '3',
        title: 'Works Across Apple & Android',
        content: "Mixed-device families? No problem. Device Tracker Plus works with both Apple and Android, so no one is left out.",
        imgName: 'mobilePhoneIcon'
    },
    {
        id: '4',
        title: 'Privacy-Focused Location Sharing',
        content: "We’re about connection, not surveillance. Location sharing is open within your family group, and each member can pause sharing when they need to. It’s tracking that builds trust, not control.",
        imgName: 'eye'
    },
];